const actions = {

    // /////////////////////////////////////////////
    // COMPONENTS
    // /////////////////////////////////////////////

    // Vertical NavMenu
    updateVerticalNavMenuWidth({ commit }, width) {
      commit('UPDATE_VERTICAL_NAV_MENU_WIDTH', width)
    },

    // VxAutoSuggest
    updateStarredPage({ commit }, payload) {
      commit('UPDATE_STARRED_PAGE', payload)
    },

    // The Navbar
    arrangeStarredPagesLimited({ commit }, list) {
      commit('ARRANGE_STARRED_PAGES_LIMITED', list)
    },
    arrangeStarredPagesMore({ commit }, list) {
      commit('ARRANGE_STARRED_PAGES_MORE', list)
    },

    // /////////////////////////////////////////////
    // UI
    // /////////////////////////////////////////////

    toggleContentOverlay({ commit }) {
      commit('TOGGLE_CONTENT_OVERLAY')
    },
    updateTheme({ commit }, val) {
      commit('UPDATE_THEME', val)
    },

    // /////////////////////////////////////////////
    // User/Account
    // /////////////////////////////////////////////

    updateUserInfo({ commit }, payload) {
      commit('UPDATE_USER_INFO', payload)
    },
    verifyUserInfo({commit}) {
      commit('SET_USER_INFO')
    },

    verifyToken({commit}) {
      commit('SET_TOKEN');
    },
    // /////////////////////////////////////////////
    // App Data
    // /////////////////////////////////////////////

    updateAppData({ commit }, payload) {
      commit('UPDATE_APP_DATA', payload)
    },
    verifyAppData({commit}) {
      commit('SET_APP_DATA')
    },
    updateUserRole({ dispatch }, payload) {
      // Make API call to server for changing role
      let role = ""

      switch(payload.userRole) {
        case 3:
          role = "owner";
          break;
        case 4:
          role = "manager";
          break;
        case 6:
          role = "school";
          break;
        case 7:
          role = "store";
          break;
        case 10:
          role = "admin";
          break;
        case 11:
          role = "superadmin";
          break;
        default: role = "public";
      }

       // Change client side
       // this.$acl.change(role);
       payload.aclChangeRole(role)
      // Change userInfo in localStorage and store
      dispatch('updateUserInfo', {userRole: role})
    },
    changeUserInsitution({commit}, institution) {

      // institution.asigned = JSON.parse(JSON.stringify(this.state.AppActiveUser.institution.asigned));

      if(institution) {
        commit('UPDATE_USER_INFO', {institution});
        return "1"
      } else {
        return "0"
      }

    }
}

export default actions
